import { useSyncExternalStore } from 'react';

function mediaQueryList(query: string): MediaQueryList | null {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(query)
    : null;
}

/** Whether `query` currently matches, re-rendering when it changes. `false` where media queries are unavailable. */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const media = mediaQueryList(query);
      media?.addEventListener('change', onChange);
      return () => media?.removeEventListener('change', onChange);
    },
    () => mediaQueryList(query)?.matches ?? false,
    () => false,
  );
}
